module.exports = __webpack_public_path__ + "static/media/ihover.ad557c81.svg";